<template lang="pug">
.container.grid-lg
  .card.mt-2
    .card-header
      .text-bold Filtrar
    .card-body
      fieldset(:disabled="loading")
        form-filter(@submit="onFilter")
  v-map.mt-2.map-style(
    ref="mapRef",
    :center="municipioLocal",
    :zoom="13",
    @idle="onMapIdle"
  )
    v-heatmap(:points="report", v-if="report", :options="{ radius: 30 }")
    .map-overlay.flex-centered(v-if="loading")
      .loading.loading-lg
  .pull-right
    small Total: {{ Math.floor(totalRepost).toLocaleString("pt-BR") }} registros
</template>

<script>
import { deepClone } from "paliari-js-utils"
import FormFilter from "./components/Filter"
import toastErrors from "@/lib/errors/toastErrors"
import docs from "@/api/indicadores/docs"
import ApiInfoService from "@/lib/ApiInfoService"

export default {
  components: { FormFilter },
  data() {
    return {
      q: {},
      bounds: {},
      zoom: 0,
      loading: false,
      report: null,
      municipioLocal: ApiInfoService.getInfo().municipio_local,
    }
  },
  methods: {
    async fetchReport() {
      try {
        this.loading = true
        const { q, bounds } = this
        this.report = await docs.mapaDensidade(this.zoom, {
          q,
          bounds,
        })
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },
    onMapIdle() {
      this.bounds = this.$refs.mapRef
        ? this.$refs.mapRef.map.getBounds().toJSON()
        : null
      this.zoom = this.$refs.mapRef ? this.$refs.mapRef.map.getZoom() : 0

      this.fetchReport()
    },
    onFilter(q) {
      this.q = deepClone(q)
      this.fetchReport()
    },
  },
  computed: {
    totalRepost() {
      let count = 0
      if (this.report && this.report.length > 0) {
        this.report.map((item) => {
          count += item.weight
        })
      }

      return count
    },
  },
}
</script>

<style lang="stylus" scoped>
.map-style {
  height: calc(100vh - 280px);
  border-radius: 10px;
  position: relative;

  .map-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.8);
  }
}
</style>
